import { render, staticRenderFns } from "./YoutubeIframe.vue?vue&type=template&id=24e2f6e8&"
import script from "./YoutubeIframe.vue?vue&type=script&setup=true&lang=ts&"
export * from "./YoutubeIframe.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports